import React, { useState, useEffect, useRef } from 'react';
import './Shop.css';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import { fireAudit } from '../utils/auditClient';   

const Shop = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const academyId = searchParams.get("academyId");
  const playerId = searchParams.get("playerId");  

  const [formData, setFormData] = useState({
    playerName: '',
    rewardPointsBalance: '',
    transactionType: '',
    rewardPoints: '',
  });
  const token = localStorage.getItem('auth-token');
  const [transactionOptions, setTransactionOptions] = useState([]);

  const baselineRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_PLAYER_SHOP}?academyId=${academyId}&playerId=${playerId}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        const data = await response.json();

        setFormData((prevFormData) => ({
          ...prevFormData,
          playerName: data.player?.user?.name || prevFormData.playerName,
          rewardPointsBalance: data.rewardBalance !== undefined ? data.rewardBalance : prevFormData.rewardPointsBalance,
          rewardPoints: '',
          playerUserId: data.player?.user?.id || null 
        }));

        if (data.transactionType) {
          setTransactionOptions(
            data.transactionType.map((type) => ({
              label: type.charAt(0) + type.slice(1).toLowerCase(),
              value: type.toLowerCase(),
            }))
          );
        }
        baselineRef.current = {
          academyId,
          playerId,
          formData: {
            playerName: data.player?.user?.name || '',
            rewardPointsBalance: data.rewardBalance || '',
            transactionType: '',
            rewardPoints: '',
          }
        };

      } catch (error) {
      }
    };

    if (academyId && playerId) {
      fetchData();
    }
  }, [academyId, playerId]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!formData.transactionType) {
      Swal.fire({
        icon: "warning",
        title: "Transaction Type Required",
        text: "Please select a transaction type before proceeding.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
  
    const requestBody = {
      academyId,
      id: playerId,
      points: formData.rewardPoints,
      type: formData.transactionType.toUpperCase(),
    };
  
    try {
      const response = await fetch(process.env.REACT_APP_API_PLAYER_SHOP, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });
  
      const data = await response.json();
  
      if (data.successMessage) {
        const oldPayload = baselineRef.current || {};
        const newPayload = {
          academyId,
          playerId,
          formData: {
            ...formData,
            rewardPointsBalance: data.rewardBalance ?? formData.rewardPointsBalance,
          },
        };
  
        const oldBalance = oldPayload?.formData?.rewardPointsBalance ?? null;
        const newBalance = newPayload.formData.rewardPointsBalance;
  
        if (oldBalance !== null && newBalance !== null && oldBalance !== newBalance) {
          fireAudit({
            entity: "player_shop",
            affected_id: formData.playerUserId,
            action: "update",
            section: "Shop",
            affected_user: formData.playerUserId,
            subSection: "RewardPoints",
            businessApi: process.env.REACT_APP_API_PLAYER_SHOP,
            businessMethod: "POST",
            oldPayload,
            newPayload,
            extra: { page: "Shop" },
          });
        }
  
        baselineRef.current = newPayload;
  
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Successfully processed!",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
  
        navigate(-1);
        setFormData({
          transactionType: "",
          rewardPoints: "",
          rewardPointsBalance: newBalance,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.error_message || "There was an issue with the transaction.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There was an issue with the transaction. Please try again.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };
  

  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/academyPlayerList" className="breadcrumb-link">Academy Player List</Link> &gt; Shop
      </div>
      <form onSubmit={handleSubmit} className="walkin-enquiry-form">
        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="text"
            id="playerName"
            name="playerName"
            className={`walkin-form  ${formData.playerName ? 'has-value' : ''}`}
            value={formData.playerName}
            placeholder="Enter Player Name"
            required
            readOnly
          />
          {formData.playerName && (
            <label htmlFor="playerName">Player Name</label>
          )}
        </div>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="number"
            id="rewardPointsBalance"
            name="rewardPointsBalance"
            className={`walkin-form  ${formData.rewardPointsBalance != null ? 'has-value' : ''}`}
            value={formData.rewardPointsBalance}
            placeholder="Enter Reward Points Balance"
            required
            readOnly
          />
          {formData.rewardPointsBalance != null && (
            <label htmlFor="rewardPointsBalance">Reward Points Balance</label>
          )}
        </div>

        <div className="form-group-transaction-type">
          <label className="form-label-transaction-type">Transaction Type</label>
          <div className="radio-group">
            {transactionOptions.map((option) => (
              <label key={option.value}>
                <input
                  type="radio"
                  name="transactionType"
                  value={option.value}
                  checked={formData.transactionType === option.value}
                  onChange={handleChange}
                /> {option.label}
              </label>
            ))}
          </div>
        </div>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="number"
            id="rewardPoints"
            name="rewardPoints"
            className={`walkin-form ${formData.rewardPoints !== '' ? 'has-value' : ''}`}
            value={formData.rewardPoints}
            onChange={handleChange}
            placeholder="0"
            required
          />
          {formData.rewardPoints !== '' && (
            <label htmlFor="rewardPoints">Reward Points*</label>
          )}
        </div>

        <div className="form-group-submit-btn">
          <button type="submit" className="submit-button">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default Shop;
